import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import StitchingtaskFilterCriteria from './StitchingtaskFilterCriteria'
import StitchingtaskListImpl from './StitchingtaskListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './StitchingtaskAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setStitchingtaskDashboardStitchingtaskList } from '../../store/slice/ManufSlice';

export default function StitchingtaskListView({setShowEdit,setStitchingtaskId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);   

    const [filteredStitchingtaskList, setFilteredStitchingtaskList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { stitchingtaskDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (stitchingtaskDashboard.stitchingtaskList.length>-1){
        setFilteredStitchingtaskList(stitchingtaskDashboard.stitchingtaskList);
        transformToCardFormat(stitchingtaskDashboard.stitchingtaskList, setCardList);
      }
    },[stitchingtaskDashboard.stitchingtaskList])

    useEffect(()=>{
          transformToCardFormat(filteredStitchingtaskList, setCardList);
      },[filteredStitchingtaskList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.assignedqty==='' && filterCriteria.receivedqty==='' && filterCriteria.taskstatusid==='' && filterCriteria.taskstatusname==='' && filterCriteria.orderid==='' && filterCriteria.productid==='' && filterCriteria.productorderid==='' && filterCriteria.workerid==='' && filterCriteria.workername==='' && filterCriteria.workertypeid==='' && filterCriteria.stitchingrate==='' ){
            setFilteredStitchingtaskList(stitchingtaskDashboard.stitchingtaskList);
            transformToCardFormat(stitchingtaskDashboard.stitchingtaskList, setCardList);

        } else {
            setFilteredStitchingtaskList(
                stitchingtaskDashboard.stitchingtaskList
                    .filter(stitchingtask=> stitchingtask.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(stitchingtask=> stitchingtask.orderid.toString().toUpperCase().includes(filterCriteria.orderid.toString().toUpperCase()))
.filter(stitchingtask=> stitchingtask.productname.toString().toUpperCase().includes(filterCriteria.productname.toString().toUpperCase()))
.filter(stitchingtask=> stitchingtask.workername.toString().toUpperCase().includes(filterCriteria.workername.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(stitchingtaskDashboard.filteredStitchingtaskList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <StitchingtaskListImpl
                    setShowEdit={setShowEdit}
                    setStitchingtaskId = {setStitchingtaskId}
                    tableList={filteredStitchingtaskList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}